import type { BillingStatus } from '@/types';

export type InterviewSchedulingBlockReason = 'trial_not_included' | 'credits_exhausted';

/** Whether create-mode interview scheduling (with transcript) is allowed on the current plan. */
export function getInterviewSchedulingBlock(
  status: BillingStatus | null | undefined,
): InterviewSchedulingBlockReason | null {
  if (!status) return 'credits_exhausted';

  const planId = status.planId ?? 'freemium_trial';
  if (planId === 'freemium_trial') {
    return 'trial_not_included';
  }

  if (status.isUnlimited) return null;

  const aiCompanyLimit = status.limits?.aiCompany ?? 0;
  if (aiCompanyLimit <= 0) {
    return 'trial_not_included';
  }

  const aiCompany = status.balances?.ai_company;
  const aiCompanyUsed = (aiCompany?.granted ?? 0) - (aiCompany?.remaining ?? 0);
  const remaining = Math.max(0, aiCompanyLimit - aiCompanyUsed);

  if (remaining <= 0) {
    return 'credits_exhausted';
  }

  return null;
}
